import UpsaleCards from './UpsaleCards'

export default UpsaleCards
